<p-select placeholder="{{ 'common.personal-information.state' | translate | titlecase }}" [(ngModel)]="selectedState"
  [options]="statesAndProvinces" styleClass="w-100" [style]="{ 'min-width': '0', height: '36px' }" name="state"
  editable="true" [disabled]="disabled" wlEditableSelectFocusFix></p-select>
